// extracted by mini-css-extract-plugin
module.exports = {"priority":"IssuePriority_priority_3nnWZ"};